import { render, staticRenderFns } from "./RELNotificacoes.vue?vue&type=template&id=4b424624&"
import script from "./RELNotificacoes.vue?vue&type=script&lang=js&"
export * from "./RELNotificacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports